import React, { useState } from "react";
import { FaYoutube, FaFacebookF, FaInstagram, FaXTwitter, FaShareNodes, FaCheck } from "react-icons/fa6";

// Follow / subscribe strip for the public episode and story pages
// (2026-10-19). Same channel links as SiteHeader.

const CHANNEL = "https://www.youtube.com/@BPlusWithBhaskar";

const LINKS = [
  { href: `${CHANNEL}?sub_confirmation=1`, label: "Subscribe", Icon: FaYoutube, cls: "bg-red-600/90 hover:bg-red-600 text-white border-red-500/40" },
  { href: "https://www.instagram.com/BPlusWithBhaskar", label: "Instagram", Icon: FaInstagram },
  { href: "https://www.facebook.com/BPlusWithBhaskar", label: "Facebook", Icon: FaFacebookF },
  { href: "https://x.com/BPlusWithBhaskar", label: "X", Icon: FaXTwitter },
];

export default function FollowCTA({ shareTitle }) {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    const url = window.location.href;
    try {
      if (navigator.share) {
        await navigator.share({ title: shareTitle || document.title, url });
        return;
      }
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      // Share sheet dismissed or clipboard blocked: nothing to do.
    }
  };

  return (
    <section className="border border-kk-gold/15 rounded-xl bg-white/[0.03] p-4 md:p-5">
      <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-5">
        <div className="flex-1 min-w-0">
          <p className="font-krushna text-kk-gold text-lg leading-tight">ప్రతి శనివారం కథాకళ — ప్రత్యక్ష ప్రసారం</p>
          <p className="text-kk-cream/60 text-sm">
            Watch Kathakala LIVE every Saturday, 8 PM CT, on{" "}
            <a href={`${CHANNEL}/streams`} target="_blank" rel="noopener noreferrer" className="text-kk-gold-light hover:text-kk-gold underline underline-offset-2">
              YouTube
            </a>
            . Subscribe and follow so you never miss a story.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          {LINKS.map(({ href, label, Icon, cls }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-semibold transition-colors ${
                cls || "bg-white/5 hover:bg-kk-gold/10 text-kk-cream/80 hover:text-kk-cream border-kk-gold/20"
              }`}
            >
              <Icon /> {label}
            </a>
          ))}
          <button
            type="button"
            onClick={share}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-kk-gold/30 bg-kk-gold/10 hover:bg-kk-gold/20 text-kk-gold text-xs font-semibold transition-colors"
          >
            {copied ? <FaCheck /> : <FaShareNodes />} {copied ? "Link copied" : "Share"}
          </button>
        </div>
      </div>
    </section>
  );
}
